(function () {
  function isJapaneseChar(ch) {
    // Hiragana, Katakana, CJK Unified Ideographs (basic set)
    return /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff]/.test(ch);
  }

  function isWhitespace(ch) {
    return /\s/.test(ch);
  }

  function buildSpansForSegment(text, container) {
    let buffer = '';
    let mode = null; // 'latin' | 'jp'

    function flushBuffer() {
      if (!buffer) return;

      if (mode === 'latin') {
        // Split into words and spaces, keep spaces as text nodes
        buffer.split(/(\s+)/).forEach((token) => {
          if (!token) return;
          if (isWhitespace(token)) {
            container.appendChild(document.createTextNode(token));
          } else {
            const span = document.createElement('span');
            span.className = 'cjp-home-intro__headline-chunk';
            span.textContent = token;
            container.appendChild(span);
          }
        });
      } else if (mode === 'jp') {
        // Each Japanese char gets its own span
        for (const ch of buffer) {
          if (isWhitespace(ch)) {
            container.appendChild(document.createTextNode(ch));
          } else {
            const span = document.createElement('span');
            span.className = 'cjp-home-intro__headline-chunk';
            span.textContent = ch;
            container.appendChild(span);
          }
        }
      } else {
        // Fallback: treat as a single span
        const span = document.createElement('span');
        span.className = 'cjp-home-intro__headline-chunk';
        span.textContent = buffer;
        container.appendChild(span);
      }

      buffer = '';
      mode = null;
    }

    for (let i = 0; i < text.length; i++) {
      const ch = text[i];

      if (isWhitespace(ch)) {
        flushBuffer();
        container.appendChild(document.createTextNode(ch));
        continue;
      }

      const charMode = isJapaneseChar(ch) ? 'jp' : 'latin';

      if (!mode) {
        mode = charMode;
      } else if (mode !== charMode) {
        flushBuffer();
        mode = charMode;
      }

      buffer += ch;
    }

    flushBuffer();
  }

  function initCjpAutoHeadlines() {
    const sections = document.querySelectorAll('[data-cjp-auto-headline]');

    sections.forEach((section) => {
      const raw = section.getAttribute('data-cjp-auto-headline');
      if (!raw) return;

      const headlineEl = section.querySelector('.cjp-home-intro__headline');
      if (!headlineEl) return;

      // Grab medallion templates
      const medallionTemplates = {};
      section
        .querySelectorAll('.js-cjp-medallion-template')
        .forEach((tpl) => {
          const type = tpl.getAttribute('data-medallion-type');
          if (type) medallionTemplates[type] = tpl;
        });

      // Split text on ^^ markers
      const parts = raw.split('^^');
      if (parts.length === 0) return;

      // First ^^ => portrait, second ^^ => circle
      const markerToType = ['portrait', 'circle'];

      // Clear existing content but keep templates in memory
      // (we'll remove them from the DOM to avoid showing)
      headlineEl.innerHTML = '';

      // Build DOM
      parts.forEach((segmentText, index) => {
        // 1) Text segment → spans
        if (segmentText && segmentText.trim() !== '') {
          buildSpansForSegment(segmentText, headlineEl);
        }

        // 2) If there is another part after this, insert a medallion
        if (index < parts.length - 1) {
          const medType = markerToType[index] || null;
          if (medType && medallionTemplates[medType]) {
            const clone = medallionTemplates[medType].cloneNode(true);
            clone.removeAttribute('hidden');
            clone.classList.remove('js-cjp-medallion-template');
            headlineEl.appendChild(clone);
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCjpAutoHeadlines);
  } else {
    initCjpAutoHeadlines();
  }
})();


// =============================
// CJP – Auto spines between sections
// =============================
(function () {
  function initSpines() {
    // Use only real <section> tags with .cjp-section so we skip header
    var sections = Array.prototype.slice.call(
      document.querySelectorAll('section.cjp-section')
    );

    console.log('[CJP spine] sections found:', sections.length);

    if (!sections.length) return;

    sections.forEach(function (section, index) {
      // NEW: don't create a spine after the *last* section (no spine towards footer)
      if (index === sections.length - 1) {
        console.log('[CJP spine] skipping last section (no spine towards footer)');
        return;
      }

      // Don't double-insert if already there
      var next = section.nextElementSibling;
      if (next && next.classList && next.classList.contains('cjp-spine-between')) {
        console.log('[CJP spine] already present after section', index);
        return;
      }

      var spineWrapper = document.createElement('div');
      spineWrapper.className = 'cjp-spine-between';
      spineWrapper.setAttribute('aria-hidden', 'true');

      // Insert directly after the section
      section.parentNode.insertBefore(spineWrapper, section.nextSibling);

      console.log('[CJP spine] inserted after section', index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpines);
  } else {
    initSpines();
  }
})();


document.addEventListener('DOMContentLoaded', function () {
  // Adjust these selectors if needed to match your card title elements
  var selectors = [
    '.card__heading',
    '.full-unstyled-link',
    '[data-product-title]'
  ];

  var nodes = document.querySelectorAll(selectors.join(', '));

  nodes.forEach(function (el) {
    var html = el.innerHTML;

    // Only touch titles that contain the exact text and don't already have a <br> before it
    if (html.includes('700ml (40%)') && !html.includes('<br>700ml (40%)')) {
      el.innerHTML = html.replace('700ml (40%)', '<br>700ml (40%)');
    }
  });
});

// =============================
// CJP – Scroll fade entrance
// One-time animation on scroll
// =============================
(function () {
  function markScrollFadeTargets() {
    // Auto-apply to all main CJP sections
    // Opt-out: add data-cjp-scroll-fade-off to any section you don't want animated
    var autoTargets = document.querySelectorAll(
      'section.cjp-section:not([data-cjp-scroll-fade-off])'
    );

    autoTargets.forEach(function (el) {
      if (!el.hasAttribute('data-cjp-scroll-fade')) {
        el.setAttribute('data-cjp-scroll-fade', '');
      }
    });
  }

  function initScrollFadeObserver() {
    var targets = document.querySelectorAll('[data-cjp-scroll-fade]');
    if (!targets.length) return;

    // If browser doesn't support IntersectionObserver, just show everything
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('cjp-in-view');
      });
      return;
    }

    // Respect reduced motion preference
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      targets.forEach(function (el) {
        el.classList.add('cjp-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cjp-in-view');
            // One-time only: stop observing once it's visible
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.1
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    markScrollFadeTargets();
    initScrollFadeObserver();
  });
})();
